// TODO: durch generierte Typen ersetzen, sobald `composer create-api-client` ein Schema dafuer liefert.
export interface NotificationSettings {
    stilleStundenAktiv: boolean
    stilleStundenVon: string
    stilleStundenBis: string
    pushAbmeldungAktiv: boolean
}

export interface InboxItem {
    id: number
    typ: string
    titel: string
    nachricht: string
    pictureBase64: string | null
    erstelltAm: string
    gelesenAm: string | null
    gelesen: boolean
}

export interface InboxResponse {
    unreadCount: number
    items: InboxItem[]
}

export const useNotificationService = () => {
    const getSettings = () =>
        useFetch({ baseURL: '/api/notification-settings/me' }).get<NotificationSettings>({})

    const updateSettings = (request: NotificationSettings) =>
        useFetch({ baseURL: '/api/notification-settings/save' }).post<NotificationSettings>({
            body: request
        })

    const sendTestPush = () =>
        useFetch({ baseURL: '/api/notification-settings/test-push' }).post<{ ok: boolean }>({
            body: {}
        })

    const listInbox = () =>
        useFetch({ baseURL: '/api/benachrichtigungen' }).get<InboxResponse>({})

    const markRead = (id: number) =>
        useFetch({ baseURL: '/api/benachrichtigungen/markiere-als-gelesen' }).post<InboxItem>({
            body: { id }
        })

    const markAllRead = () =>
        useFetch({ baseURL: '/api/benachrichtigungen/alle-als-gelesen' }).post<{
            markiert: number
        }>({ body: {} })

    return {
        getSettings,
        updateSettings,
        sendTestPush,
        listInbox,
        markRead,
        markAllRead
    }
}
